import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { SharedService } from './sharedService';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};
const PREFIX = 'property-tax'

@Injectable({
  providedIn: 'root'
})
export class PropertyTaxService extends BaseService {

  constructor(public http: HttpClient, public sharedService: SharedService) {
    super(http, sharedService);
  }
  public getForm(form): Observable<any> {
    return this.http.get(this.sharedService.apiUrl(PREFIX + '/get-form/' + form), {}).pipe(
      map(res => {
        return res;
      })
    );
  }

  public saveForm(form): Observable<any> {
    return this.http.post(this.sharedService.apiUrl(PREFIX + '/save-form'), form, httpOptions).pipe(
      map(res => {
        return res;
      })
    );
  }
  public setBoundary(boundary): Observable<any> {
    return this.http.post(this.sharedService.apiUrl(PREFIX + '/set-boundary'), boundary, httpOptions).pipe(
      map(res => {
        return res;
      })
    );
  }

  public setBuilding(boundary): Observable<any> {
    return this.http.post(this.sharedService.apiUrl(PREFIX + '/set-building'), boundary, httpOptions).pipe(
      map(res => {
        return res;
      })
    );
  }

  public setPropertyTax(propertyTax): Observable<any> {
    return this.http.post(this.sharedService.apiUrl(PREFIX), propertyTax, httpOptions).pipe(
      map(res => {
        return res;
      })
    );
  }

  public deletePropertyTax(id: any): Observable<any> {
    return this.http.delete(this.sharedService.apiUrl(PREFIX + '/deletePropertyTax/' + id), httpOptions).pipe(
      tap((resource: any) => this.log(`resource deleted`)),
      catchError(this.handleError<any>('deleted'))
    );
  }

  public deletePropertyTaxLot(id: any): Observable<any> {
    return this.http.delete(this.sharedService.apiUrl(PREFIX + '/deletePropertyTaxLot/' + id), httpOptions).pipe(
      tap((resource: any) => this.log(`resource deleted`)),
      catchError(this.handleError<any>('deleted'))
    );
  }

  public setLot(lot): Observable<any> {
    return this.http.post(this.sharedService.apiUrl(PREFIX + '/set-lot'), lot, httpOptions).pipe(
      map(res => {
        return res;
      })
    );
  }
  public getLot(id): Observable<any> {
    return this.http.get(this.sharedService.apiUrl(PREFIX + '/get-lot/' + id), httpOptions).pipe(
      map(res => {
        return res;
      })
    );
  }
  public getLotByIlot(id): Observable<any> {
    return this.http.get(this.sharedService.apiUrl(PREFIX + '/get-lotByIlot/' + id), httpOptions).pipe(
      map(res => {
        return res;
      })
    );
  }

  public getPropertyTaxByBuildingId(buildingId): Observable<any> {
    return this.http.get(this.sharedService.apiUrl(PREFIX + '/bybuildingid/' + buildingId), {}).pipe(
      map(res => {
        return res;
      })
    );
  }
  public getPropertyTaxesByBuildingId(buildingId): Observable<any> {
    return this.http.get(this.sharedService.apiUrl(PREFIX + '/taxesBybuildingid/' + buildingId), {}).pipe(
      map(res => {
        return res;
      })
    );
  }
  public getLotByLotId(lotId): Observable<any> {
    return this.http.get(this.sharedService.apiUrl(PREFIX) + '/bylotid/' + lotId, {}).pipe(
      map(res => {
        return res;
      })
    );
  }

  public getBoundary(id): Observable<any> {
    return this.http.get(this.sharedService.apiUrl(PREFIX + '/get-boundary/' + id), httpOptions).pipe(
      map(res => {
        return res;
      })
    );
  }

  deleteAttachment(prc: any): Observable<Blob> {
    const httpOptions = {
      params: new HttpParams().set('p_id', prc.id).set('p_row', prc.p_row).set('type', prc.type)
    };
    let process$ = this.http.delete<any>(this.sharedService.apiUrl(PREFIX + '/attachment'), httpOptions).pipe(
      map((res: Response) => { return res }), catchError(this.handleError<any>('delete process attachement'))
    )
    return process$;
  }

  downloadLotListReport(filterObject: any, headers: any): Observable<Blob> {
    const httpOptions = {
      params: new HttpParams().set('filter.object', this.stringifyWithUTC(filterObject)).set('headers', JSON.stringify(headers)),
      responseType: 'blob' as 'json'
    };
    let lotList$ = this.http.get<any>(this.sharedService.apiUrl(PREFIX + '/lot-list-report'), httpOptions).pipe(
      map((res: Response) => { return res }), catchError(this.handleError<any>('download lot list report'))
    )
    return lotList$;
  }

  downloadPropertyListReport(filterObject: any, headers: any): Observable<Blob> {
    const httpOptions = {
      params: new HttpParams().set('filter.object', this.stringifyWithUTC(filterObject)).set('headers', JSON.stringify(headers)),
      responseType: 'blob' as 'json'
    };
    let propList$ = this.http.get<any>(this.sharedService.apiUrl(PREFIX + '/property-list-report'), httpOptions).pipe(
      map((res: Response) => { return res }), catchError(this.handleError<any>('download property list report'))
    )
    return propList$;
  }

  public declarePropertyTax(data): Observable<any> {
    return this.http.post(this.sharedService.apiUrl(PREFIX + '/declare'), data, httpOptions).pipe(
      map(res => {
        return res;
      })
    );
  }

}
